import React from "react";
import elementsStyle from "../styles/elements.module.scss"

export function Container({ children }) {
    return <div className={elementsStyle.container}>{children}</div>
}
export function Row({ children }) {
    return <div className={elementsStyle.row}>{children}</div>
}
